const meetingType = [
    { key: "CALL", value: "CALL" },
    { key: "WEB_MEETING", value: "WEB_MEETING" },
    { key: "FACE_TO_FACE_MEETING", value: "FACE_TO_FACE_MEETING" },
    { key: "VISIT_AT_FAIR", value: "VISIT_AT_FAIR" },
];

export { meetingType };